import { createStore } from 'vuex'
import news from './modules/news'
import category from './modules/categories'
import events from './modules/events'
import fotos from './modules/fotos'
import videos from './modules/videos'
import carousel from './modules/carousel'
import menu from './modules/menu'
import leader from './modules/leader'
import faq from './modules/faq'
import allPage from './modules/allPage'
import usefulLink from './modules/usefulLink'
import ourService from './modules/ourService'
import tadbirlar from './modules/tadbirlar'
import kurslar from './modules/kurslar'
import pagesImages from './modules/pagesImages'

export default new createStore({
    modules: { allPage, pagesImages, faq, news, category, events, fotos, videos, carousel, menu, leader, usefulLink, ourService, tadbirlar, kurslar },
    strict: true,
});
